import { render } from "./App.vue?vue&type=template&id=cd790536"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./fonts.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=cd790536&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__